import { Action } from 'redux'
import { SynchronizeActions } from '../../reducers/synchronize/actionNames'

export const requestFlushRooms = (): IRequestFlushRooms => ({
  type: SynchronizeActions.RequestRoomsFlush,
})

export const roomsFlushed = (): IRoomsFlushed => ({
  type: SynchronizeActions.RoomsFlushed,
})

export const requestFlushEvents = (): IRequestFlushEvents => ({
  type: SynchronizeActions.RequestEventsFlush,
})

export const eventsFlushed = (): IEventsFlushed => ({
  type: SynchronizeActions.EventsFlushed,
})

export const flushDataForSync = (): IFlushDataForSync => ({
  type: SynchronizeActions.FlushDataForSync,
})

export const dataForSyncFlushed = (): IFlushedDataForSync => ({
  type: SynchronizeActions.FlushedDataForSync,
})

export const dbError = (e: Error): IFlushError => ({
  e,
  type: SynchronizeActions.FlushError,
})

export type IFlushedDataForSync = Action<SynchronizeActions.FlushedDataForSync>
export type IFlushDataForSync = Action<SynchronizeActions.FlushDataForSync>
export type IRequestFlushRooms = Action<SynchronizeActions.RequestRoomsFlush>
export type IRoomsFlushed = Action<SynchronizeActions.RoomsFlushed>
export type IRequestFlushEvents = Action<SynchronizeActions.RequestEventsFlush>
export type IEventsFlushed = Action<SynchronizeActions.EventsFlushed>

export interface IFlushError extends Action<SynchronizeActions.FlushError> {
  e
}
